
















import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import auth from '@/auth'
import { AuthRequest } from '@/apiv3'

@Component({})
export default class Auth extends Vue {
  public blocked = false
  public req: AuthRequest = { email: '', password: '' }

  public auth (): void {
    this.blocked = true

    auth.adminNoAuthClient().Auth(this.req).then((resp) => {
      if (resp.authorized) {
        this.$router.push('/adm/')
      }
    }).finally(() => {
      this.blocked = false
    })
  }
}
